import { RadioField } from "components/RenderInput"
import { FORM_NAMES } from "constants/index"
import React from "react"
import { connect } from "react-redux"
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import { change, Field } from "redux-form"

const ProductTypeTab = ({ change }) => {
  return (
    <React.Fragment>
      <Card>
        <CardHeader>
          <h4>PRODUCT TYPE</h4>
        </CardHeader>
        <CardBody>
          <Row>
            <Col>
              <label>Select your product here:</label>
            </Col>
          </Row>
          <Row>
            <Col className="mt-1">
              <Field
                name="productType"
                component={RadioField}
                type="radio"
                label={
                  <span>
                    New Product &nbsp;
                    <span style={{ fontWeight: "normal" }}>
                      (Create a product here - one time payment)
                    </span>
                  </span>
                }
                value="1"
                onChange={() => {
                  change("info.stripeProduct", null)
                  change("info.stripePrice", null)
                }}
              />
            </Col>
          </Row>
          <Row className="my-2">
            <Col xs="auto">
              <Field
                name="productType"
                component={RadioField}
                type="radio"
                label={
                  <span>
                    Stripe Product &nbsp;
                    <span style={{ fontWeight: "normal" }}>
                      (Select a product and price from Stripe - one time or
                      recurring payments)
                    </span>
                  </span>
                }
                value="2"
              />
            </Col>
          </Row>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

const mapDispatchToProps = dispatch => ({
  change: (field, value) =>
    dispatch(change(FORM_NAMES.PRODUCT, `${field}`, value)),
})

export default connect(null, mapDispatchToProps)(ProductTypeTab)
